module.exports = __webpack_public_path__ + "media/images/patent/y_9-c0e2290c1749a6eca5c717a9702fba1c.jpg";